import {
  GET_RECENT_SEARCHES,
  FreestyleRecentSearch,
} from './getRecentSearches';
import { CLEAR_RECENT_SEARCHES } from './clearRecentSearches';

const recentSearchesMockData = [
  {
    id: '1',
    label: 'hoodies',
  },
  {
    id: '2',
    label: 'jeans',
  },
  {
    id: '3',
    label: 'sneakers',
  },
];

const getRecentSearchesMock = (recentSearches: FreestyleRecentSearch[]) => ({
  request: {
    query: GET_RECENT_SEARCHES,
  },
  result: {
    data: {
      shopContent: {
        id: 'shop_content-1',
        recentSearches,
      },
    },
  },
});

export const recentSearchesMock = getRecentSearchesMock(recentSearchesMockData);

export const clearHistoryMock = {
  request: {
    query: CLEAR_RECENT_SEARCHES,
  },
  result: {
    data: {
      clearRecentSearches: {
        result: {
          id: 'shop_content-1',
          recentSearches: [],
        },
      },
    },
  },
};

export default getRecentSearchesMock;
